// The string tables live in translations/; this module keeps the names the language
// provider was built around and points them at those tables.
export { LOCALES as locales, translations as dictionaries, type Locale, type Translations as Dictionary } from "@/lib/translations"
